import { Box, Grid, Typography, useTheme } from '@mui/material';
import { BarChart } from '@mui/x-charts';

const truncate = (text, max = 28) => {
  if (!text) return '';
  return text.length > max ? `${text.slice(0, max)}...` : text;
};

const formatMinutes = (minutes = 0) => {
  const total = Number(minutes || 0);
  const hrs = Math.floor(total / 60);
  const mins = Math.floor(total % 60);

  if (hrs <= 0) return `${mins}min`;

  return `${hrs}h${mins > 0 ? ` ${mins}min` : ''}`;
};

const ParadasNaProducao = ({ data = [] }) => {
  const theme = useTheme();

  const setores = [...new Set(data.map((item) => item?.setor || 'SEM SETOR'))];

  const tipos = [...new Set(data.map((item) => item?.tipo || 'SEM TIPO'))];

  const chartData = setores
    .map((setor) => {
      const row = { setor };

      tipos.forEach((tipo) => {
        row[tipo] = data
          .filter(
            (item) =>
              (item?.setor || 'SEM SETOR') === setor &&
              (item?.tipo || 'SEM TIPO') === tipo
          )
          .reduce((acc, item) => acc + Number(item?.tempo_apontado || 0), 0);
      });

      row.total = tipos.reduce((acc, tipo) => acc + row[tipo], 0);

      return row;
    })
    .sort((a, b) => b.total - a.total);

  const colors = [
    theme.palette.primary.light,
    theme.palette.primary.main,
    theme.palette.primary.dark,
  ];

  if (!chartData.length) return null;

  return (
    <Grid item xs={12} md={6}>
      <Box gap={2} height="100%" display="flex" flexDirection="column">
        <Typography variant="h5" fontWeight="bold">
          Paradas na Produção
        </Typography>
        <Box mt="auto" width="100%">
          <BarChart
            layout="horizontal"
            height={Math.max(chartData.length * 60, 200)}
            margin={{ left: 220, top: 100, right: 20 }}
            series={tipos.map((tipo, index) => ({
              label: tipo,
              data: chartData.map((item) => item[tipo]),
              stack: 'total',
              color: colors[index % colors.length],
              valueFormatter: (value) => formatMinutes(value),
            }))}
            yAxis={[
              {
                scaleType: 'band',
                data: chartData.map((item) => truncate(item.setor)),
                categoryGapRatio: 0.5,
              },
            ]}
            xAxis={[
              {
                label: 'Tempo apontado',
                min: 0,
                valueFormatter: (value) => formatMinutes(value),
              },
            ]}
          />
        </Box>
      </Box>
    </Grid>
  );
};

export default ParadasNaProducao;
